import React, { useState, useEffect } from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import Api from '../../../api/global.service';
import BlockUi from 'react-block-ui';

import useEtiquetas from '../../../hooks/useEtiquetas';
import transformWord from '../../../utils/transformWord';

const ParcelasResumenColmenas = ({ id_ciclo }) => {
  const [dataGrafica, setDataGrafica] = useState([]);
  const [blocking, setBlocking] = useState(true);
  const { etiquetas } = useEtiquetas();

  useEffect(() => {
    if (id_ciclo > 0) {
      getData();
    }
  }, [id_ciclo]);

  const getData = () => {
    setBlocking(true);
    Api.search('dashboards/apiarios/colmenas', {
      filter: [{ column: 'id_ciclo', operator: '=', value: id_ciclo }],
    }).then(response => {
      const chartData = response.data.map(item => ({
        name: item.tipo,
        total: item.total,
      }));
      setDataGrafica(chartData);
      setBlocking(false);
    }).catch(() => {
      setDataGrafica([]);
      setBlocking(false);
    });
  };

  return (
    <BlockUi tag="div" message="" blocking={blocking} renderChildren={true} style={{ height: '95%' }}>
      <div className="row p-10 mt-2" style={{ backgroundColor: '#F3EFEC', margin: 10, borderRadius: 10, height: '100%' }}>
        <p className="dashboard-titulo-grafica">Colmenas por tipo en {transformWord(etiquetas?.parcela, ['plural','lowercase'])}:</p>
        <div className="col-xl-12 col-md-12">
          <ResponsiveContainer width="100%" height={250}>
            <BarChart
              data={dataGrafica}
              margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="name" />
              <YAxis />
              <Tooltip />
              <Legend />
              <Bar dataKey="total" fill="#789D16" name="Colmenas" isAnimationActive={false} />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>
    </BlockUi>
  );
};

export default ParcelasResumenColmenas;
